import React from 'react';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { overlay } from 'overlay-kit';
import { logger } from '@zep/core-logger';
import { LockIcon } from '@/icons';
import { useUpsellingGuard, useUserPlanManager } from '@/shared/plan';
import { BuildProFeatureCoachmarkAnchor } from '../components/BuildProFeatureCoachmark';
import { FeatureUpsellModal } from '../components/FeatureUpsellModal';
import { useFocusTarget } from '../components/focus/useFocusTarget';
import { useBuildFormContext } from '../form/schema';
import { ToggleOptionContainer } from './ToggleOptionContainer';
export const TogglePublicField = () => {
  const {
    watch,
    setValue
  } = useBuildFormContext();
  const {
    t
  } = useTranslation(['build']);
  const {
    userPlanManager
  } = useUserPlanManager();
  const upsellingGuard = useUpsellingGuard();
  const isPublic = watch('isPublic');
  const featurePlanType = userPlanManager.getFeaturePlanType('PRIVATE_QUIZ');
  const ref = useFocusTarget<HTMLDivElement>('isPublic');
  return <div ref={ref} className="flex flex-col gap-sm" tabIndex={0} data-sentry-component="TogglePublicField" data-sentry-source-file="TogglePublicField.tsx">
      <ToggleOptionContainer optionIcon={<LockIcon size="sm" fill={ICON_COLOR.neutral} />} optionTitle={t('build:hideFromExplore.title')} optionDescription={t('build:hideFromExplore.description')} isOn={!isPublic} planType={featurePlanType} isBadgeVisible={true} onToggle={() => {
      logger.track('isPublic_select', {
        value: !isPublic
      });
      upsellingGuard(() => {
        setValue('isPublic', !isPublic, {
          shouldDirty: true,
          shouldTouch: true
        });
      }, {
        feature: 'PRIVATE_QUIZ',
        from: 'isPublic',
        moreConditionForGuard: isPublic === true,
        onGuard: () => {
          overlay.open(({
            unmount
          }) => <FeatureUpsellModal feature="PRIVATE_QUIZ" onClose={unmount} />);
        }
      });
    }} renderToggle={toggle => <BuildProFeatureCoachmarkAnchor feature="PRIVATE_QUIZ">
            {toggle}
          </BuildProFeatureCoachmarkAnchor>} data-sentry-element="ToggleOptionContainer" data-sentry-source-file="TogglePublicField.tsx" />
    </div>;
};